type Setting = string | number | boolean | SettingObject | SettingArray;

interface SettingObject {
    [key: string]: Setting;
}

interface SettingArray {
    [index: number]: Setting;
}

interface Settings {
    [key: string]: SettingObject | Setting;
}

// type PropertyAccessor<T, K extends keyof T> = K extends string
//   ? T[K] extends Record<string, unknown>
//     ? `${K}.${PropertyAccessor<T[K], keyof T[K]>}` | K
//     : K
//   : never;

// type NestedObjectType<T> = {
//   [K in PropertyAccessor<T, keyof T>]: K extends `${infer Head}.${infer Rest}`
//     ? Head extends keyof T
//       ? Rest extends PropertyAccessor<T[Head], keyof T[Head]>
//         ? NestedObjectType<T[Head]>[Rest]
//         : never
//       : never
//     : K extends keyof T
//     ? T[K]
//     : never;
// };

// type SettingsPath = keyof NestedObjectType<typeof settings>;

// type SettingsPathStr<T extends SettingsPath> = NestedObjectType<typeof settings>[T];

let pageTitle: string | null;

import settings from '@/settings.json';

settings.signalR.signalRUrl = process.env.VUE_APP_SIGNAL_R_URL ?? settings.signalR.signalRUrl;

settings.ledigajobbWeb = process.env.VUE_APP_LEDIGAJOBB_WEB ?? settings.ledigajobbWeb;

settings.swagger = process.env.VUE_APP_SWAGGER_URL ?? "https://api.pages.a.jobdev.se/swagger";

settings.accounts.domainName = process.env.VUE_APP_ACCOUNTS_LEDIGAJOBB ?? settings.accounts.domainName;

settings.accounts.api.domainName = process.env.VUE_APP_ACCOUNTS_LEDIGAJOBB_API ?? settings.accounts.api.domainName;

settings.accounts.googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID ?? settings.accounts.googleClientId;

settings.accounts.appleClientId = process.env.VUE_APP_APPLE_CLIENT_ID ?? settings.accounts.appleClientId;

export const SettingsContext = {

    constants: {

        accountsDomainName: settings.accounts.domainName,

        accountsApiDomainName: settings.accounts.api.domainName,

        googleClientId: settings.accounts.googleClientId,

        appleClientId: settings.accounts.appleClientId,

        stage: process.env.VUE_APP_STAGE ?? 'local',

        crossDomainAuthentication: settings.crossDomainAuthentication
    },

    getApiUrl(name: keyof typeof settings.dataUrls | keyof typeof settings.matrix, matrixEndpoint = false): string {
        const url = (settings[matrixEndpoint ? 'matrix' : 'dataUrls'] as SettingObject)[name];

        if (typeof url === 'string' && url.includes('dummy-data')) {

            return `/${url}`;
        }

        return `${matrixEndpoint ? process.env.VUE_APP_MATRIX_BASE : process.env.VUE_APP_API_BASE}${url}`;
    },

    get pageTitle(): string {
        if (pageTitle == null) {
            pageTitle = settings['pageTitle'] as string;
        }

        return pageTitle;
    },

    get<T extends Setting | Settings | SettingObject | SettingArray | undefined>(path: string): T {

        const parts = path.split('.');

        let scope = settings as Settings;

        for (const part of parts) {

            scope = scope[part] as Settings;

            const type = typeof (scope);

            if (type === 'undefined') {

                return undefined as T;
            }
        }

        return scope as T;
    },

    getStage(): string {

        return process.env.VUE_APP_STAGE ?? 'local';
    }
};
